import axios from 'axios';
import type { TblBenutzerRequest, TblBenutzerResponseWrapper } from './ServiceModels';

export interface User {
    id: string;
    name: string;
}

export interface Error {
    id: number;
    position: string;
    recordId: string;
    description: string;
    recommendation: string;
}

export interface UserServiceConfig {
    appId: () => string;
    serviceUrl: () => string;
    sid: () => string;
    userId: () => string;
    branchId: () => string;
}

export default class UserService {

    private readonly config: UserServiceConfig;

    constructor(config: UserServiceConfig) {
        this.config = config;
    }

    public async getUsers(branchId:string|undefined = undefined): Promise<User[]> {
        if(branchId) {
        const request: TblBenutzerRequest = { Filiale: branchId || this.config.branchId(), AppID: this.config.appId() };
        const response = await axios.post<TblBenutzerResponseWrapper>(`${this.config.serviceUrl()}/Tbl_Benutzer`, request);
        const responseData = response.data.Tbl_Benutzer_response;
        if (responseData.ServiceErrors) {
            const serviceErrors: Error[] = responseData.ServiceErrors.map((error) => ({
                id: error.ERRORNUMBER,
                position: error.ERRORPOSITION,
                recordId: error.ERRORRECORDID,
                description: error.ERRORDESCRIPTION,
                recommendation: error.ERRORRECOMMENDATION,
            }));
            // eslint-disable-next-line no-throw-literal
            throw { serviceErrors };
        }
        return responseData.Tbl_Benutzer
            .map((serviceObj) => ({ id: serviceObj.Nummer.toString(), name: serviceObj.Name }));
        }
        return [];
    }
}
